import React from 'react';
import ExpenseResolutionByProjectWorkspace from './ExpenseResolutionByProjectWorkspace';

/** 지출결의등록2 — 사업 기준 · 전자증빙→과목 매핑 · 과목별 결의 일괄 생성 */
export default function ExpenseResolutionRegister2() {
  return <ExpenseResolutionByProjectWorkspace />;
}
